import axios from 'axios';
import { cached_method, async_cached_method } from '@/utils/logic';

const query_cache = {};

export default {
  getExplorer: async (explorer_filters, cancel_token) => {
    if (!explorer_filters.get_filter_value('business_process'))
    //if (!explorer_filters.business_process)
      throw 'getExplorerFilter() → Filter business_process is required';
    if (!explorer_filters.get_filter_value('centro'))
      throw "getExplorerFilter() → Centro filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/explorer/`,
      {
        params: explorer_filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      },
    );
    return response.data;
  },

  globalSearch: async (explorer_filters, cancel_token) => {
    //TODO: upodate multiprocess
    if (explorer_filters.get_filter_value('business_process'))
      throw 'Filter business_process must not be in here';
    if (!explorer_filters.get_filter_value('centro'))
      throw "getExplorerFilter() → Centro filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/global_search/`,
      {
        params: explorer_filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      },
    );
    return response.data;
  },

  getExplorerCalendar: async (
    explorer_filters,
    cancel_token
  ) => {    
    if (!explorer_filters.get_filter_value('centro'))
      throw "getExplorerCalendar() → Centro filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/explorer_calendar/`,
      {
        params: explorer_filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      },
    );
    return response.data;
  }, 

  getTodoCalendar: async (explorer_filters, cancel_token) => {
    if (!explorer_filters.get_filter_value('centro'))
      throw "getTodoList() → Centro filter is required";
      const response = await axios.get(
        `${explorer_filters.get_filter_value('centro')}/unit/todo_calendar/`,
        {
          params: explorer_filters.as_query(),
          cancelToken: (cancel_token || {}).token,
        },
      );
    
    return response.data;
  },

  getQUnit: async (centro, pk) => {
    const epk = encodeURIComponent(pk);
    const url = `${centro}/unit/${epk}/`;
    const response = await axios.get(url);
    return response.data;
  },

  getQUnitRelated: async(explorer_filters, cancel_token) => {
    if (!explorer_filters.get_filter_value('business_process'))
      throw 'getQUnitRelated() → Filter business_process is required';
    if (!explorer_filters.get_filter_value('centro'))
      throw "getQUnitRelated() → Centro filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/related_list/`,
      {
        params: explorer_filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      },
    );
    return response.data;
  },

  getTransitionCandidates: async (centro, pk) => {
    const epk = encodeURIComponent(pk);
    const url = `${centro}/unit/${epk}/get_transition_candidates`;
    const response = await axios.get(url);
    return response.data;
  },

  getFieldsToCollectForFiltering: async_cached_method('getFieldsToCollectForFiltering', async (centro, bpReference) => {
    // TODO: TEST THIS !!!!!!!!!
    const response = await axios.get(
      `${centro}/unit/get_fields_definition_to_collect_for_filtering/`,
      {
        params: {business_process: bpReference},
      },
    );
    return response.data;
  }),

  getFieldsByTypeToCollectForFiltering: async_cached_method('getFieldsByTypeToCollectForFiltering', async (centro, bpReference) => {
    const bp = bpReference ? `?business_process=${encodeURIComponent(bpReference)}` : '';
    const url = `${centro}/unit/get_fields_by_type_to_collect_for_filtering/${bp}`;
    const response = await axios.get(url);
    return response.data;
  }),

  getFieldsToCollectDuringCreation: async (
    centro,
    bp_reference,
    origin_qunit,
    values,
  ) => {
    const params = {
      business_process: bp_reference,
      values: values || null,
    };
    if (origin_qunit) {
      params.origin_qunit = origin_qunit;
    }
    const response = await axios.post(
      `${centro}/unit/get_fields_to_collect_with_preset_values/`,
      params,
    );
    return response.data;
  },

  /* New method to vuetify components */
  getFieldsDefinitionToCollectDuringCreation: async (
    centro,
    bp_reference,
    origin_qunit,
    values,
  ) => {
    // TODO: TEST THIS !!!!!!!!!
    const params = {business_process: bp_reference};
    if (origin_qunit) {
      params.origin_qunit = origin_qunit;
    }
    const response = await axios.get(
      `${centro}/unit/get_fields_definition_to_collect_during_creation/`,
      {params: params}
    );
    return response.data;
  },

  getFieldsToCollectDuringTransition: async (centro, pk, transitionId) => {
    // TODO: TEST THIS !!!!!!!!!
    const response = await axios.get(
      `${centro}/unit/${encodeURIComponent(pk)}/get_fields_to_collect_during_transition/`,
      {params: {
        transition_id: transitionId,
      }},
    );
    return response.data;
  },

  getTransitionCandidateResponsibles: async (centro, pk, transitionId) => {
    const epk = encodeURIComponent(pk);
    const url = `${centro}/unit/${epk}/get_transition_candidate_responsibles/?transition_id=${transitionId}`;
    const response = await axios.get(url);
    return response.data;
  },

  canCreate: async (centro, business_process) => {
    const url = `${centro}/unit/can_create?business_process=${business_process}`;
    const response = await axios.get(url);
    return response.data;
  },

  getQUnitFile: async (centro, pk, attribute, path, version, title, pmethod) => {
    //
    // FIXME: Don't use path
    //
    const epk = encodeURIComponent(pk);
    const value = encodeURIComponent(path);
    const v = version 
      ? `&version=${version}`
          : '';
    const doc_title = title 
      ? `&title=${encodeURIComponent(title)}`
          : '';
    
    const file_method = pmethod 
      ? `&pmethod=${pmethod}`
          : '';
    
    const url = `${centro}/unit/${epk}/get_qunit_file/?attribute=${attribute}&path=${value}${v}${doc_title}${file_method}`;
    const response = await axios.get(url, {responseType: 'arraybuffer'});
    //return response.data
    return response;
  },

  createUnit: async (sitePath, formdata) => {
    // formdata is a FormData() instance
    const url = `${sitePath}/unit/create_and_execute_initial_transition/`
    
    const response = await axios({
      method: 'post',
      url: url,
      data: formdata,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data
  },

  executeTransition: async (sitePath, pk, form_data) => {
    const epk = encodeURIComponent(pk)
    const url = `${sitePath}/unit/${epk}/execute_transition/`

    const response = await axios({
      method: 'post',
      url: url,
      data: form_data,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data
  },
  
  getUserNotifications: async (explorer_filters) => {
    if (!explorer_filters.get_filter_value('business_process'))
      explorer_filters.set_filter({business_process: 'NOTIF_DEFAULT'}) ;
    if (!explorer_filters.get_filter_value('centro'))
      throw "getExplorerFilter() → Centro filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/get_user_notifications/`,
      {
        params: explorer_filters.as_query()
      },
    );
    return response.data;
  },

  getUserNotificationsCount: async (sitePath) => {
    let url = `${sitePath}/unit/get_user_notifications_count/`
    const response = await axios.get(url)    

    return response.data
  },
  
  executeReadTransitionUserNotification: async (sitePath, pk) => {
    var notifications_ids = [pk]
    const url = `${sitePath}/unit/execute_read_notifications/`
    const response = await axios({
      method: 'post',
      url: url,
      data: {notifications_ids:notifications_ids},
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data        
  },

  executeReadNotifications: async (sitePath, pks) => {
    const epks = encodeURIComponent(pks)
    const url = `${sitePath}/unit/execute_read_notifications/`
    const response = await axios({
      method: 'post',
      url: url,
      data: {notifications_ids:pks},
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data        
  },

  getTodoList: async (explorer_filters, cancel_token) => {
    if (!explorer_filters.get_filter_value('centro'))
      throw "getTodoList() → Site filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/explorer_user_todo_list/`,
      {
        params: explorer_filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      },
    );
    return response.data;
  },

  getRelated: async (explorer_filters, cancel_token) => {
    if (!explorer_filters.get_filter_value('centro'))
      throw "getRelated() → Site filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/qunit_related_qunits_list/`,
      {
        params: explorer_filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      },
    );
    return response.data;
  },
  getIds: async (explorer_filters, cancel_token) => {
    if (!explorer_filters.get_filter_value('business_process'))
      throw 'getExplorerFilter() → Filter business_process is required';
    if (!explorer_filters.get_filter_value('centro'))
      throw "getExplorerFilter() → Centro filter is required";
    const response = await axios.get(
      `${explorer_filters.get_filter_value('centro')}/unit/explore_ids/`,
      {
        params: explorer_filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      },
    );
    return response.data;
  },
}
